export const generateExtraQuerySearchResult = ({
  queryLocationId,
  queryLocationLevel,
  querySource,
}) => {
  return `lid=${queryLocationId}&ll=${queryLocationLevel}&fr=${encodeURIComponent(
    querySource
  )}`
}

export const generateQuerySearchResult = ({
  searchParams,
  queryLocationId,
  queryLocationLevel,
  querySource,
  withHash = false,
  page = 1,
}) => {
  const extraQuery = generateExtraQuerySearchResult({
    queryLocationId,
    queryLocationLevel,
    querySource,
  })
  const notContainPrefix = searchParams !== '?'
  const withHashQuery = withHash ? '#search-section' : ''
  const withPageQuery = page > 1 ? `&page=${page}` : ''

  if (notContainPrefix) {
    // Search params is already contains ?
    // Doesn't need to add ? again
    return `${searchParams}${withPageQuery}&${extraQuery}${withHashQuery}`
  } else {
    return `?r=1${withPageQuery}&${extraQuery}${withHashQuery}`
  }
}

export const generateQueryKecamatan = ({
  searchParams,
  withHash = false,
  page = 1,
}) => {
  const notContainPrefix = searchParams !== '?'
  const withHashQuery = withHash ? '#filter-section' : ''
  const withPageQuery = page > 1 ? `&page=${page}` : ''

  if (notContainPrefix) {
    // Search params is already contains ?
    // Doesn't need to add ? again
    return `${searchParams}${withPageQuery}${withHashQuery}`
  } else {
    return `?r=1${withPageQuery}${withHashQuery}`
  }
}
